module.exports = {"id":"163761","name":"Curtis Davies","rating":"77","photo":"./data/images/photos/4/163761.png","club":{"name":"Derby County","logo":"./data/images/clubs/DerbyCounty.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CurtisDavies0.json
// module id = 890
// module chunks = 0